import { render, staticRenderFns } from "./HintsPage.vue?vue&type=template&id=6066402b&scoped=true"
import script from "./HintsPage.js?vue&type=script&lang=js&external"
export * from "./HintsPage.js?vue&type=script&lang=js&external"
import style0 from "./HintsPage.vue?vue&type=style&index=0&id=6066402b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066402b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CircleLoader: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/CircleLoader.vue').default,HintsSection: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/wordle/HintsSection.vue').default,AnswerSection: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/wordle/AnswerSection.vue').default,AnswersTable: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/games/AnswersTable.vue').default,WordListInterlinkDirector: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/results/WordListInterlinkDirector/WordListInterlinkDirector.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
